export default function SiteFooter() {
  return (
    <footer className="no-print mt-8 bg-gray-100 px-4 py-5 text-xs leading-6 text-gray-600">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-0 text-center">
        <span><strong className="font-semibold text-gray-700">상호명</strong> 모빗</span>
        <span aria-hidden="true" className="hidden text-gray-300 sm:inline">|</span>
        <span><strong className="font-semibold text-gray-700">대표자</strong> 백인식</span>
        <span aria-hidden="true" className="hidden text-gray-300 sm:inline">|</span>
        <span><strong className="font-semibold text-gray-700">사업자등록번호</strong> 194-72-00559</span>
        <span aria-hidden="true" className="hidden text-gray-300 sm:inline">|</span>
        <span><strong className="font-semibold text-gray-700">통신판매업 신고번호</strong> 2026-경기김포-4342</span>
        <span aria-hidden="true" className="hidden text-gray-300 sm:inline">|</span>
        <span>
          <strong className="font-semibold text-gray-700">사업장 주소</strong>{" "}
          <a
            className="text-blue-700 underline"
            href="https://www.google.com/maps/search/%EA%B2%BD%EA%B8%B0%EB%8F%84+%EA%B9%80%ED%8F%AC%EC%8B%9C+%ED%86%B5%EC%A7%84%EC%9D%8D+%EA%B9%80%ED%8F%AC%EB%8C%80%EB%A1%9C2053%EB%B2%88%EA%B8%B8+42-2+1%EC%B8%B5?entry=gmail&source=g"
            target="_blank"
            rel="noreferrer"
          >
            경기도 김포시 통진읍 김포대로2053번길 42-2 1층
          </a>
        </span>
        <span aria-hidden="true" className="hidden text-gray-300 sm:inline">|</span>
        <span>
          <strong className="font-semibold text-gray-700">고객센터</strong>{" "}
          <a className="text-blue-700 underline" href="tel:0226646877">02-2664-6877</a>
        </span>
      </div>
    </footer>
  );
}
